var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['resize-handle', _vm.settings.darkMode && 'theme--dark'],style:(_vm.style),on:{"mousedown":_vm.startDrag}})}
var staticRenderFns = []

export { render, staticRenderFns }